import { useEffect, useState, useMemo } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import axios from "axios";

import * as helpers from "../utils/utils.js"
import { useClientId } from "../context/context.js";

const apiBaseUrl = process.env.REACT_APP_API_URL;

export function useExpenses() {
  const clientId = useClientId();
  const queryClient = useQueryClient();

  const retrieveExpenses = async () => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/clients/${clientId}/expenses`,
    );
    return response.data;
  };

  const updateExpenseRequest = async ({ id, expenseData }) => {
    const { data } = await axios.put(`${apiBaseUrl}/clients/${clientId}/expenses/${id}`, expenseData);
    return data;
  };

  const createExpenseRequest = async (expenseData) => {
    const { data } = await axios.post(`${apiBaseUrl}/clients/${clientId}/expenses`, expenseData);
    return data;
  };

  const deleteExpenseRequest = async (id) => {
    const { data } = await axios.delete(`${apiBaseUrl}/clients/${clientId}/expenses/${id}`);
    return data;
  };

  const { mutateAsync: createExpense } = useMutation({
    mutationFn: createExpenseRequest,
    onSuccess: (data) => {
      console.log('Expense created:', data);
      queryClient.invalidateQueries({ queryKey: ['expenseData'] });
    },
    onError: (error) => console.error("Error creating expense:", error),
  });

  const { mutateAsync: updateExpense } = useMutation({
    mutationFn: updateExpenseRequest,
    onSuccess: (data) => {
      console.log('Expense updated:', data);
      queryClient.invalidateQueries({ queryKey: ['expenseData'] });
    },
    onError: (error) => console.error("Error updating expense:", error),
  });

  const { mutateAsync: deleteExpense } = useMutation({
    mutationFn: deleteExpenseRequest,
    onSuccess: (data) => {
      console.log('Expense Deleted:', data);
      queryClient.invalidateQueries({ queryKey: ['expenseData'] });
    },
    onError: (error) => console.error("Error deleting expense:", error),
  });


  return {
    retrieveExpenses,
    createExpense,
    updateExpense,
    deleteExpense,
  };
}
